import {apiHost} from '../lib/aliyun/config'
class ConfigService {
  config = {};

  constructor() {
    ConfigService.instance = ConfigService.instance || this;
    return ConfigService.instance;
  }

  setConfig() {
    return fetch(`${apiHost}/getConfig`).then(res => {
      return res.json().then(data => {
        this.config = data.data;
        return data.data;
      });
    });
  }

  getFullName = oId => {
    return this.config[oId].fullName;
  };

  getShortName = oId => {
    return this.config[oId].shortName;
  };

  getRecordConfig = oId => {
    return this.config[oId].record;
  };

  getRecordInterval = oId => {
    return this.config[oId].recordInterval;
  };

  canEditShimo = role => {
    if (/秘书|鉴定/.test(role)) {
      return true;
    }
    return false;
  };

  getOrganizedSystem = () => {
    let oSystem = [];
    for (const key in this.config) {
      if (this.config.hasOwnProperty(key)) {
        const element = this.config[key];
        oSystem.push({ oId: key, oName: element.fullName });
      }
    }
    return oSystem;
  };

  getOrgTitle = (oId,caseId) =>{
    let oShortName = this.config[oId].shortName.slice(0, 1);
    let caseYear = caseId.slice(0, 4);
    let number = caseId.slice(4);
    return `${this.config[oId].fullName}网上庭审：（${caseYear}）${oShortName}仲字第 ${number} 号`
  }
  
}

const config = new ConfigService();
export default config;
